module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-next.png?v=92040896";